var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 1.25L13.1875 0.625C13.0312 0.5 12.7812 0.5 12.6562 0.625L7 6.28125L1.3125 0.624999C1.1875 0.499999 0.9375 0.499999 0.78125 0.624999L0.1875 1.25C0.03125 1.40625 0.03125 1.625 0.1875 1.78125L6.71875 8.34375C6.875 8.46875 7.09375 8.46875 7.25 8.34375L13.7812 1.78125C13.9375 1.625 13.9375 1.40625 13.7812 1.25Z",
    fill: "#2D5049",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/ChevronBottom.f8cb87bcc0500e2dbf939604ac10e9fc.svg";
export { ForwardRef as ReactComponent };